import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { useEasterEgg } from '../context/EasterEggContext';

const Navbar = ({ discordUser, onLogout, onConnect }) => {
  const navigate = useNavigate();
  const { toggleEasterEgg } = useEasterEgg();
  const [clickCount, setClickCount] = useState(0);

  const handleLogoClick = () => {
    const newClickCount = clickCount + 1;
    setClickCount(newClickCount);
    if (newClickCount >= 3) {
      toggleEasterEgg();
      setClickCount(0);
    }
  };

  const scrollTo = (id) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={handleLogoClick}>
        <Link to="/">
          <img src="/tansicon.png" alt="ShoczTweaks Logo" className="nav-logo-img" />
          <span className="nav-logo-text">
            Shocz<span className="text-gradient">Tweaks</span>
          </span>
        </Link>
      </div>
      <div className="navbar-links">
        <button onClick={() => scrollTo('comparison')}>Results</button>
        <button onClick={() => scrollTo('why-shocz')}>Advantage</button>
        <button onClick={() => scrollTo('optimizations')}>Pricing</button>
        <button onClick={() => scrollTo('reviews')}>Reviews</button>
        <button onClick={() => scrollTo('pc-builds')}>PC Builds</button>
        <button onClick={() => scrollTo('faq')}>FAQ</button>
        
        {discordUser ? (
          <div className="nav-profile-wrapper">
            <Link to="/hub" className="nav-hub-link">Member Hub</Link>
            <div className="nav-profile-container">
              <div className="nav-profile">
                <img 
                  src={discordUser.avatar 
                    ? `https://cdn.discordapp.com/avatars/${discordUser.id}/${discordUser.avatar}.png`
                    : 'https://cdn.discordapp.com/embed/avatars/0.png'} 
                  alt="Profile" 
                  className="nav-avatar"
                />
                <span className="nav-username">{discordUser.username}</span>
              </div>
              <button className="nav-logout-btn" onClick={onLogout}>Log Out</button>
            </div>
          </div>
        ) : (
          <div className="nav-auth-buttons">
            <button className="nav-login-btn" onClick={onConnect}>Log In</button>
            <button className="nav-cta" onClick={() => scrollTo('optimizations')}>Get Started</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;